
import React from "react";

type H4Props = {
  children: React.ReactElement| any;
  bold?: boolean;
  fontType?: string;
  color?: string;
  className?: string;
};
const H4: React.FC<H4Props> = ({
  children,
  bold,
  color = "text-blueishblack",
  fontType = "regular",
  className = "",
}): React.ReactElement => {
  const _fType = bold ? "bold" : fontType;

  return <h4 className={`text-2xl  ${color} ${className}`}>{children}</h4>;
};

export default H4;
